/* eslint-disable no-shadow */
import React from 'react';
import ReactDOM from 'react-dom';

import firmaYaTheme from './theme/FirmaYa';
import gseTheme from './theme/Gse';
import letmicertTheme from './theme/Letmicert';
import licMarketEcuLetmiTheme from './theme/LicMarketEcuLetmi';
import pancertTheme from './theme/Pancert';
import colfacturaTheme from './theme/Colfactura';
import firmaMailTheme from './theme/FirmaMail';
import colnominaTheme from './theme/Colnomina';
import superGuardaTheme from './theme/SuperGuarda';
import ciasTheme from './theme/Cias';
import mySelfTheme from './theme/MySelf';

import './index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import App from './routes/App';
import { getParametersAction } from './actions/general.action';

const request = new XMLHttpRequest();
request.open('GET', document.location, false);
request.send(null);
const appName = request.getResponseHeader('appName');
const tenant = request.getResponseHeader('tenant');

const SetFaviconTitleApp = (apptheme) => {
  const { favicon, title } = apptheme.app;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = `/${favicon}`;
  document.title = title;
};

const SelectTheme = (app, tenant) => {
  let selectedTheme;
  switch (app) {
    case 'firmaya':
      selectedTheme = firmaYaTheme;
      localStorage.setItem('APP_THEME', 'orange');
      break;
    case 'license':
      if (tenant === 'letmicert') {
        selectedTheme = letmicertTheme;
        localStorage.setItem('APP_THEME', 'light');
        break;
      } else if (tenant === 'letmiecu') {
        selectedTheme = licMarketEcuLetmiTheme;
        localStorage.setItem('APP_THEME', 'light');
        break;
      } else if (tenant === 'pancert') {
        selectedTheme = pancertTheme;
        localStorage.setItem('APP_THEME', 'light');
        break;
      } else {
        selectedTheme = gseTheme;
        localStorage.setItem('APP_THEME', 'light');
        break;
      }
    case 'colfactura':
      selectedTheme = colfacturaTheme;
      localStorage.setItem('APP_THEME', 'dark');
      break;
    case 'firmamail':
      selectedTheme = firmaMailTheme;
      localStorage.setItem('APP_THEME', 'light');
      break;
    case 'colnomina':
      selectedTheme = colnominaTheme;
      localStorage.setItem('APP_THEME', 'dark');
      break;
    case 'superguarda':
      selectedTheme = superGuardaTheme;
      localStorage.setItem('APP_THEME', 'light');
      break;
    case 'bemyself':
      selectedTheme = mySelfTheme;
      localStorage.setItem('APP_THEME', 'dark');
      break;
    case 'cias':
      selectedTheme = ciasTheme;
      localStorage.setItem('APP_THEME', 'light');
      break;
    default:
      selectedTheme = gseTheme;
      localStorage.setItem('APP_THEME', 'light');
      break;
  }
  // Setea configuracion de icono y titulo de aplicación
  SetFaviconTitleApp(selectedTheme);
  return selectedTheme;
};

const theme = SelectTheme(appName, tenant);

function loadScript(src, position, id) {
  if (!position || !src) return;
  const urlParams = new URL(src).searchParams;
  const apiKey = urlParams.get('key');
  if (!apiKey || /[^a-zA-Z0-9_-]/.test(apiKey)) {
    return;
  }
  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);

  const safeBase = 'https://maps.googleapis.com/maps/api/js';
  script.src = `${safeBase}?key=${apiKey}&libraries=places`;

  position.appendChild(script);
}

const getApiGMaps = async () => {
  const paramApps = await getParametersAction('license', 'ParameterApiKeyGoogle', tenant);
  if (paramApps) {
    const paramApi = paramApps.find((param) => param?.parameterType === 'ParameterApiKeyGoogle');
    const keyApiGMaps = paramApi?.parameterValue;
    if (typeof window !== 'undefined' && keyApiGMaps) {
      if (!document.querySelector('#google-maps')) {
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=${keyApiGMaps}&libraries=places`,
          document.querySelector('head'),
          'google-maps',
        );
      }
    }
  }
};

getApiGMaps();

ReactDOM.render(theme ? <App appName={appName} tenant={tenant} theme={theme} /> : null, document.getElementById('App'));
